export const NEWS_TRANSLATION_ENABLED = false;
export const REMOVE_ACCOUNT_ENABLED = false;
export const PROFILE_LANGUAGE_ENABLED = false;
export const NEWS_PUBLICATION_MODE_ENABLED = false;
export const NEWS_INTERESTS_ENABLED = true;
export const NEWS_VIEWS_COUNT_ENABLED = false;
export const TV_SETTINGS_ENABLED = true;
export const ALL_CONTRIBUTIONS_BROADCAST_ENABLED = true;
